if (!customElements.get('deployer-pack-builder')) {
  customElements.define(
    'deployer-pack-builder',

    class PackBuilder extends HTMLElement {
      constructor() {
        super();
        this.cardsAddToCartButton = this.querySelectorAll('.quick-add-pack-builder--add');
        this.packBuilderCards = this.querySelectorAll('.quick-add-builder--card');
      }

      connectedCallback() {
        this.addEventListener('click', (event) => {
          if (event.target.closest('.quick-add-pack-builder--add')) {
            this.dispatchVariantData(event);
          }
        });
        this.addEventListener('click', (event) => {
          if (event.target.closest('.quick-add-builder--card')) {
            event.target.closest('.card__content').querySelector('.quick-add__submit').click();
          }
        });
      }

      disconnectedCallback() {}

      async dispatchVariantData(event) {
        //this.handleAddToCartText(event);
        event.preventDefault();
        const variantId = event.target.closest('.card__content').querySelector('input[name="id"]').value;
        const variantData = await this.getVariantData(
          event.target.closest('.card__content').querySelector('input[name="id"]').dataset.handle,
          variantId
        );
        document.dispatchEvent(
          new CustomEvent('pack-builder-selected-variants-changed', {
            detail: variantData,
          })
        );
      }

      async dispatchVariantFromQuickAdd(variantData) {
        document.dispatchEvent(
          new CustomEvent('pack-builder-selected-variants-changed', {
            detail: variantData,
          })
        );
      }

      handleAddToCartText(event) {
        const addToCartText = event.target.closest('.quick-add-pack-builder').querySelector('.addtocart--text--basic');
        const addToCartTextSuccess = event.target
          .closest('.quick-add-pack-builder')
          .querySelector('.addtocart--text--success');
        if (event.target.closest('.quick-add-pack-builder')) {
          addToCartText.style.display = 'none';
          addToCartText.style.opacity = '0';
          addToCartTextSuccess.style.display = 'block';
          addToCartTextSuccess.style.opacity = '1';

          setTimeout(() => {
            addToCartText.style.display = 'inline-block';
            addToCartText.style.opacity = '1';
            addToCartTextSuccess.style.display = 'none';
            addToCartTextSuccess.style.opacity = '0';
          }, 1000);
        }
      }

      async getVariantData(productHandle, variantId) {
        try {
          const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
          const data = await response.json();
          const variant = data.variants.find((variant) => variant.id === parseInt(variantId));
          if (data.variants.length == 1) {
            variant.featured_image = {
              src: data.featured_image,
              alt: data.title,
            };
            variant.title = data.title;
          }
          return variant;
        } catch (error) {
          console.error('Error:', error);
        }
      }
    }
  );
}

if (!customElements.get('deployer-pack-builder-progress-bar')) {
  customElements.define(
    'deployer-pack-builder-progress-bar',

    class DeployerPackBuilderProgressBar extends HTMLElement {
      constructor() {
        super();
        this.thresholds = [];
        this.discounts = [];
        if (this.progressType === 'progress_step_price') {
          this.topStepsLabels = this.querySelectorAll('.pack-builder-progress-bar--top-item');
          this.steps = this.querySelectorAll('.pack-builder-progress-bar--item');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold * 100));
            this.discounts.push(parseInt(step.dataset.discount * 100));
          });
        } else {
          this.steps = this.querySelectorAll('.pack-builder-progress-bar--product--container');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold));
            this.discounts.push(parseInt(step.dataset.discount));
          });
          this.progressBarsContainers = this.querySelectorAll('.pack-builder-progress-bar--product--container');
        }
      }

      connectedCallback() {
        document.addEventListener('pack-builder-total-price-changed', (e) => {
          if (this.progressType === 'progress_step_price') {
            this.updateProgressBar(e.detail.totalPrice);
            this.updateProgressText(e.detail);
          } else {
            this.updateProductProgressBar(e.detail);
          }
        });
      }

      updateProductProgressBar(data) {
        this.progressBarsContainers.forEach((progressbar, index) => {
          if (data.thresholdIndex >= index + 1) {
            progressbar.classList.add('pack-builder-progress-bar--product--container--completed');
          } else {
            progressbar.classList.remove('pack-builder-progress-bar--product--container--completed');
          }
        });
      }

      updateProgressBar(totalPrice) {
        const progressBarInner = this.querySelector('.pack-builder-progress-bar--inner');

        // Limite maximale (position visuelle du dernier step)
        const maxLeft = parseInt(this.steps[this.steps.length - 1].style.left);

        // Définir des valeurs initiales
        let previousLeft = 0;
        let previousThreshold = 0;

        // Retirer la classe "completed" de tous les steps avant de commencer
        this.steps.forEach((step, index) => {
          step.classList.remove('completed');
          this.topStepsLabels[index].classList.remove('completed'); // Pour les labels si besoin
        });

        // Boucle à travers les étapes pour trouver la bonne largeur de la barre
        for (let index = 0; index < this.steps.length; index++) {
          const step = this.steps[index];
          const topStepLabel = this.topStepsLabels[index];
          const stepLeft = parseInt(step.style.left); // La position visuelle de l'étape
          const threshold = this.thresholds[index]; // Le seuil correspondant à l'étape

          // Si le totalPrice est inférieur au seuil de cette étape
          if (totalPrice < threshold) {
            // Calculer la progression entre l'étape précédente et l'étape actuelle
            const percentageBetweenSteps = (totalPrice - previousThreshold) / (threshold - previousThreshold);
            const relativeLeft = previousLeft + percentageBetweenSteps * (stepLeft - previousLeft);

            // Mettre à jour la largeur de la barre sans dépasser l'étape actuelle
            progressBarInner.style.width = `${Math.min(relativeLeft, stepLeft)}%`;
            return; // On arrête ici après avoir trouvé la bonne largeur
          }

          // Si on a atteint ou dépassé le seuil, la barre atteint ce step
          previousLeft = stepLeft;
          previousThreshold = threshold;
          progressBarInner.style.width = `${stepLeft}%`; // Fixer la barre à cette étape
          step.classList.add('completed');
          topStepLabel.classList.add('completed');
        }

        // Si on dépasse le dernier seuil, on fixe la barre à 100%
        if (totalPrice >= this.thresholds[this.thresholds.length - 1]) {
          progressBarInner.style.width = '100%';
        }
      }

      updateProgressText(data) {
        const amountNeededSpan = this.querySelector('.pack-builder-summary--text-amount-needed');
        const discountSpan = this.querySelector('.pack-builder-summary--text-discount');

        const amountNeeded = this.thresholds[data.nextThresholdIndex] - data.totalPrice;
        amountNeededSpan.innerHTML = formatPrice(amountNeeded);
        discountSpan.innerHTML = formatPrice(this.discounts[data.nextThresholdIndex]);

        // if the last threshold is reached, show the success message and hide the summary text and summary disabled text
        if (data.nextThresholdIndex === this.thresholds.length) {
          this.querySelector('.pack-builder-progress-bar--text--success').classList.remove('hidden');
          this.querySelector('.pack-builder-progress-bar--text').classList.add('hidden');
        } else {
          this.querySelector('.pack-builder-progress-bar--text--success').classList.add('hidden');
          this.querySelector('.pack-builder-progress-bar--text').classList.remove('hidden');
        }
      }
    }
  );
}

if (!customElements.get('pack-builder-summary')) {
  customElements.define(
    'pack-builder-summary',

    class PackBuilderSummary extends HTMLElement {
      constructor() {
        super();
        this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        this.details = this.querySelector('details.pack-builder-summary--details');

        if (this.isDesktop && this.details) {
          this.details.setAttribute('open', 'true');
        }
        this.deployerPackBuilder = this.closest('.section').querySelector('deployer-pack-builder');
        this.summaryProductList = this.querySelector('.pack-builder-summary--product-list');
        this.productsCount = this.dataset.productsCount;
        this.minProduct = this.dataset.minProduct;
        this.minProductForDiscount = this.dataset.minProductForDiscount;
        this.submitForm = this.querySelector('button[name="add"]');
        this.form = this.querySelector('form');
        this.thresholds = [];
        this.discounts = [];
        this.totalPrice = 0;
        this.discountCode = '';
        this.progressType = this.dataset.progressType;
        if (this.progressType === 'progress_step_price') {
          this.steps = this.closest('.section').querySelectorAll('.pack-builder-progress-bar--item');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold * 100));
            this.discounts.push(parseInt(step.dataset.discount * 100));
          });
        } else {
          this.steps = this.closest('.section').querySelectorAll('.pack-builder-progress-bar--product--container');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold));
            this.discounts.push(parseInt(step.dataset.discount));
          });
          this.progressBarsContainers = this.closest('.section').querySelectorAll(
            '.pack-builder-progress-bar--product--container'
          );
        }
      }

      connectedCallback() {
        document.addEventListener('pack-builder-selected-variants-changed', (e) => {
          const selectedVariant = e.detail;
          this.handleSelectedVariant(selectedVariant);
          this.increaseProductCount();
        });
        document.addEventListener('pack-builder-total-price-changed', (e) => {
          this.updatePrices(e.detail);
          if (this.progressType === 'progress_step_price') {
            this.getDiscountCode(e.detail.thresholdIndex);
          }
          this.updateSummaryText(e.detail);
          this.handleSavingsState(e.detail.thresholdIndex);
        });
        this.restoreSelectedVariantsFromSessionStorage();
      }

      disconnectedCallback() {}

      handleSelectedVariant(selectedVariant) {
        this.createVariantItem(selectedVariant);
        this.updateFormInputs();
        this.saveSelectedVariantsToSessionStorage(selectedVariant);
        this.getTotalPrice(); // Recalcule le prix total après l'ajout d'un produit
      }

      saveSelectedVariantsToSessionStorage(selectedVariant) {
        let savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants')) || [];

        const existingVariantIndex = savedVariants.findIndex((variant) => variant.id === selectedVariant.id);

        if (existingVariantIndex !== -1) {
        } else {
          // Sinon, ajoute le variant avec une quantité de 1
          selectedVariant.quantity = 1;
          savedVariants.push(selectedVariant);
        }

        sessionStorage.setItem('packBuilderSelectedVariants', JSON.stringify(savedVariants));
      }

      restoreSelectedVariantsFromSessionStorage() {
        const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants')) || [];
        savedVariants.forEach((selectedVariant) => {
          for (let i = 0; i < selectedVariant.quantity; i++) {
            document.dispatchEvent(
              new CustomEvent('pack-builder-selected-variants-changed', {
                detail: selectedVariant,
              })
            );
          }
        });
      }

      createVariantItem(variant, crosssell = null) {
        const existingItem = this.summaryProductList.querySelector(`[data-id="${variant.id}"]`);
        if (existingItem) {
          const quantity = parseInt(
            existingItem.querySelector('.pack-builder-summary--product-list--item--quantity').innerHTML
          );
          existingItem.querySelector('.pack-builder-summary--product-list--item--quantity').innerHTML = quantity + 1;
          existingItem.dataset.quantity = quantity + 1;
          // update Price
          existingItem.querySelector('.pack-builder-summary--product-list--item--price').innerHTML = formatPrice(
            variant.price * existingItem.dataset.quantity
          );
          // change the quantity of the selected variant in the session storage
          const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants')) || [];
          const selectedVariantIndex = savedVariants.findIndex((variant) => variant.id === variant.id);
          savedVariants[selectedVariantIndex].quantity = existingItem.dataset.quantity;
          sessionStorage.setItem('packBuilderSelectedVariants', JSON.stringify(savedVariants));
        } else {
          const item = document.createElement('li');
          item.dataset.id = variant.id;
          item.dataset.price = variant.price;
          item.dataset.quantity = 1;
          item.dataset.compareAtPrice = variant.compare_at_price == null ? 0 : variant.compare_at_price;
          item.classList.add('pack-builder-summary--product-list--item');
          item.innerHTML = `
            <div class="pack-builder-summary--product-list--item--content">
              <div class="pack-builder-summary--product-list--item--image">
              <span class="pack-builder-summary--product-list--item--quantity">1</span>
                <img src="${variant.featured_image.src}" alt="${variant.name.split('-')[0]}" width="60" height="60" />
              </div>
              <div class="pack-builder-summary--product-list--item--inner">
                <div class="pack-builder-summary--product-list--item--title">
                  ${variant.name.split('-')[0]}
                  ${
                    variant.options.length > 0 && variant.option1 !== 'Default Title'
                      ? `<br><span class="pack-builder-summary--product-list--item--option-name">${
                          variant.title ? variant.title : ''
                        }</span>`
                      : ''
                  }
                </div>
                <div class="pack-builder-summary--product-list--item--prices">
                  <s class="pack-builder-summary--product-list--item--compare-at-price"></s>
                  <span class="pack-builder-summary--product-list--item--price">${formatPrice(variant.price)}</span>
                </div>
              </div>
            </div>
            <div class="pack-builder-summary--product-list--item--remove" data-id="${variant.id}">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M256-192.35 192.35-256l224-224-224-224L256-767.65l224 224 224-224L767.65-704l-224 224 224 224L704-192.35l-224-224-224 224Z"/></svg>
            </div>
            `;
          this.summaryProductList.appendChild(item);
          item.querySelector('.pack-builder-summary--product-list--item--remove').addEventListener('click', (event) => {
            this.removeItem(event.currentTarget.dataset.id);
            // remove the selected variant from the session storage
            const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants')) || [];
            const selectedVariantIndex = savedVariants.findIndex(
              (variant) => variant.id === event.currentTarget.dataset.id
            );
            savedVariants.splice(selectedVariantIndex, 1);
            sessionStorage.setItem('packBuilderSelectedVariants', JSON.stringify(savedVariants));
            if (crosssell != null) {
              crosssell.querySelector('.deployer-switch input').checked = false;
              crosssell.classList.remove('toggle-cross-sell__product--active');
            }
            this.updateFormInputs();
            this.getTotalPrice(); // Recalcule le prix total après la suppression d'un produit
          });
        }

        if (this.progressType !== 'progress_step_price') {
          let allProducts = [];
          this.summaryProductList.querySelectorAll('.pack-builder-summary--product-list--item').forEach((item) => {
            allProducts.push({
              price: item.dataset.price,
              quantity: item.dataset.quantity,
              id: item.dataset.id,
            });
          });
          this.changeFreeProduct(allProducts);
        }
      }

      changeFreeProduct(allProducts) {
        const minProductForDiscount = parseInt(this.minProductForDiscount);
        let totalQuantity = 0;
        let products = [];

        // Réinitialiser les prix de tous les produits avant de recalculer
        this.summaryProductList.querySelectorAll('.pack-builder-summary--product-list--item').forEach((item) => {
          const originalPrice = parseFloat(item.dataset.price) * parseInt(item.dataset.quantity);
          item.querySelector('.pack-builder-summary--product-list--item--compare-at-price').innerHTML = '';
          item.querySelector('.pack-builder-summary--product-list--item--price').innerHTML = formatPrice(originalPrice);
        });

        // Collecter tous les produits avec leurs prix, IDs, et quantités
        allProducts.forEach((product) => {
          const price = parseFloat(product.price);
          const quantity = parseInt(product.quantity);
          totalQuantity += quantity;

          // Ajouter chaque produit (avec son ID, son prix et sa quantité)
          products.push({ price, id: product.id, quantity: quantity });
        });

        // Vérifier si le total des produits atteint le seuil pour des réductions
        const discountCount = Math.floor(totalQuantity / minProductForDiscount);

        if (discountCount > 0) {
          // Trier les produits par prix croissant pour offrir les moins chers
          products.sort((a, b) => a.price - b.price);

          let totalSavings = 0;
          let remainingDiscounts = discountCount;

          // Appliquer la réduction sur les `discountCount` produits les moins chers
          products.forEach((productToDiscount) => {
            if (remainingDiscounts > 0) {
              const productElement = this.summaryProductList.querySelector(`[data-id="${productToDiscount.id}"]`);
              if (productElement) {
                const originalTotalPrice = productToDiscount.price * productToDiscount.quantity;

                // Si la quantité du produit est inférieure ou égale aux réductions restantes
                if (productToDiscount.quantity <= remainingDiscounts) {
                  totalSavings += productToDiscount.price * productToDiscount.quantity;
                  remainingDiscounts -= productToDiscount.quantity;

                  // Afficher le prix barré et mettre le prix à 0€
                  productElement.querySelector(
                    '.pack-builder-summary--product-list--item--compare-at-price'
                  ).innerHTML = formatPrice(originalTotalPrice);
                  productElement.querySelector('.pack-builder-summary--product-list--item--price').innerHTML = '0€';
                } else {
                  // Si la quantité dépasse les réductions restantes
                  const discountedPrice = productToDiscount.price * (productToDiscount.quantity - remainingDiscounts);
                  totalSavings += productToDiscount.price * remainingDiscounts;
                  remainingDiscounts = 0;

                  // Afficher le prix barré et le prix réduit
                  productElement.querySelector(
                    '.pack-builder-summary--product-list--item--compare-at-price'
                  ).innerHTML = formatPrice(originalTotalPrice);
                  productElement.querySelector('.pack-builder-summary--product-list--item--price').innerHTML =
                    formatPrice(discountedPrice);
                }
              }
            }
          });

          // Mettre à jour le tableau des remises avec la nouvelle valeur
          this.discounts = [totalSavings];
        } else {
          // Aucune réduction, réinitialiser le tableau
          this.discounts = [];
        }
      }

      removeItem(variantId) {
        this.decreaseProductCount(
          this.summaryProductList
            .querySelector(`.pack-builder-summary--product-list--item[data-id="${variantId}"]`)
            .querySelector('.pack-builder-summary--product-list--item--quantity').innerHTML
        );
        this.querySelector(`.pack-builder-summary--product-list--item[data-id="${variantId}"]`).remove();
        if (this.progressType !== 'progress_step_price') {
          let allProducts = [];
          this.summaryProductList.querySelectorAll('.pack-builder-summary--product-list--item').forEach((item) => {
            allProducts.push({
              price: item.dataset.price,
              quantity: item.dataset.quantity,
              id: item.dataset.id,
            });
          });
          this.changeFreeProduct(allProducts);
        }
        this.getTotalPrice();
      }

      decreaseProductCount(value) {
        this.productsCount = parseInt(this.productsCount) - parseInt(value);
        this.querySelector('.pack-builder-summary--title-product-count').innerHTML = this.productsCount;
        this.handleSummaryTextState();
        this.handleButtonState();
        this.handleTotalsState(this.productsCount);
      }

      increaseProductCount() {
        this.productsCount = parseInt(this.productsCount) + 1;
        this.querySelector('.pack-builder-summary--title-product-count').innerHTML = this.productsCount;
        this.handleSummaryTextState();
        this.handleButtonState();
        this.getTotalPrice();
        this.handleTotalsState(this.productsCount);
      }

      handleSummaryTextState() {
        if (this.productsCount >= this.minProduct) {
          this.querySelector('.pack-builder-summary--text').classList.remove('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.add('hidden');
        } else {
          this.querySelector('.pack-builder-summary--disabled-text-products-needed').innerHTML =
            this.minProduct - this.productsCount;
          this.querySelector('.pack-builder-summary--text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.remove('hidden');
        }
      }

      handleButtonState() {
        if (this.productsCount >= this.minProduct) {
          this.querySelector('.pack-builder-summary--add').disabled = false;
          this.querySelector('.pack-builder-summary--add-text').classList.remove('hidden');
          this.querySelector('.pack-builder-summary--add-text--disabled').classList.add('hidden');
        } else {
          this.querySelector('.pack-builder-summary--add').disabled = true;
          this.querySelector('.pack-builder-summary--add-text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--add-text--disabled').classList.remove('hidden');
        }
      }

      handleTotalsState(productCount) {
        if (productCount > 0) {
          this.querySelector('.pack-builder-summary--totals').classList.remove('hidden');
        } else {
          this.querySelector('.pack-builder-summary--totals').classList.add('hidden');
        }
      }

      handleSavingsState(thresholdIndex) {
        if (this.progressType === 'progress_step_price') {
          if (thresholdIndex !== null) {
            this.querySelector('.pack-builder-summary--savings').classList.remove('hidden');
            this.updateSavingsValue(this.discounts[thresholdIndex]);
          } else {
            this.querySelector('.pack-builder-summary--savings').classList.add('hidden');
          }
        } else {
          if (thresholdIndex >= this.minProductForDiscount) {
            this.querySelector('.pack-builder-summary--savings').classList.remove('hidden');
            this.updateSavingsValue(this.discounts[0]);
          } else {
            this.querySelector('.pack-builder-summary--savings').classList.add('hidden');
          }
        }
      }

      getTotalPrice() {
        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'));
        this.totalPrice = items.reduce((total, item) => {
          return total + parseFloat(item.dataset.price * item.dataset.quantity);
        }, 0);
        const thresholdIndex = this.getThresholdIndex(this.totalPrice);
        const getNextThresholdIndex = this.getNextThresholdIndex(this.totalPrice);
        document.dispatchEvent(
          new CustomEvent('pack-builder-total-price-changed', {
            detail: {
              totalPrice: this.totalPrice,
              thresholdIndex: thresholdIndex,
              nextThresholdIndex: getNextThresholdIndex,
            },
          })
        );
      }

      getThresholdIndex(totalPrice) {
        let lastIndex = null;
        this.thresholds.forEach((threshold, index) => {
          if (totalPrice >= threshold) {
            lastIndex = index;
          }
        });
        if (this.progressType !== 'progress_step_price') {
          lastIndex = this.productsCount;
        }
        return lastIndex;
      }

      getNextThresholdIndex(totalPrice) {
        let lastIndex = -1;
        this.thresholds.forEach((threshold, index) => {
          if (totalPrice >= threshold) {
            lastIndex = index;
          }
        });
        if (this.progressType !== 'progress_step_price') {
          lastIndex = this.productsCount;
        }
        return lastIndex + 1;
      }

      updatePrices(data) {
        let totalPrice = data.totalPrice;
        if (this.progressType === 'progress_step_price') {
          if (data.thresholdIndex !== null) {
            this.querySelector('.pack-builder-summary--compare').innerHTML = formatPrice(totalPrice);
            totalPrice = totalPrice - this.discounts[data.thresholdIndex];
          } else {
            this.querySelector('.pack-builder-summary--compare').innerHTML = '';
          }
        } else {
          if (data.thresholdIndex >= this.minProductForDiscount) {
            this.querySelector('.pack-builder-summary--compare').innerHTML = formatPrice(totalPrice);
            totalPrice = totalPrice - this.discounts[0];
          } else {
            this.querySelector('.pack-builder-summary--compare').innerHTML = '';
          }
        }
        this.querySelector('.pack-builder-summary--price').innerHTML = formatPrice(totalPrice);
      }

      updateSavingsValue(savings) {
        this.querySelector('.pack-builder-summary--savings-value').innerHTML = formatPrice(savings);
      }

      updateSummaryText(data) {
        if (this.progressType === 'progress_step_price') {
          const amountNeededSpan = this.querySelector('.pack-builder-summary--text-amount-needed');
          const discountSpan = this.querySelector('.pack-builder-summary--text-discount');

          const amountNeeded = this.thresholds[data.nextThresholdIndex] - data.totalPrice;
          amountNeededSpan.innerHTML = formatPrice(amountNeeded);
          discountSpan.innerHTML = formatPrice(this.discounts[data.nextThresholdIndex]);
        }

        // if the last threshold is reached, show the success message and hide the summary text and summary disabled text
        if (this.progressType === 'progress_step_price') {
          if (data.nextThresholdIndex === this.thresholds.length) {
            this.querySelector('.pack-builder-summary--success-text').classList.remove('hidden');
            this.querySelector('.pack-builder-summary--text').classList.add('hidden');
            this.querySelector('.pack-builder-summary--disabled-text').classList.add('hidden');
          } else {
            this.querySelector('.pack-builder-summary--success-text').classList.add('hidden');
            this.querySelector('.pack-builder-summary--text').classList.remove('hidden');
          }
        } else {
          if (data.thresholdIndex >= this.minProductForDiscount) {
            this.querySelector('.pack-builder-summary--success-text').classList.remove('hidden');
            this.querySelector('.pack-builder-summary--text').classList.add('hidden');
            this.querySelector('.pack-builder-summary--disabled-text').classList.add('hidden');
          } else if (data.thresholdIndex !== 0) {
            const productNeededSpan = this.querySelector('.pack-builder-summary--text-products-needed');
            productNeededSpan.innerHTML = this.dataset.minProductForDiscount - this.productsCount;
            this.querySelector('.pack-builder-summary--success-text').classList.add('hidden');
            this.querySelector('.pack-builder-summary--text').classList.remove('hidden');
          } else {
            this.querySelector('.pack-builder-summary--success-text').classList.add('hidden');
            this.querySelector('.pack-builder-summary--disabled-text').classList.remove('hidden');
            this.querySelector('.pack-builder-summary--text').classList.add('hidden');
          }
        }
      }

      updateFormInputs() {
        this.resetMainFormInputs();
        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'));
        items.forEach((item, index) => {
          const inputId = document.createElement('input');
          inputId.type = 'hidden';
          inputId.name = `items[${index}][id]`;
          inputId.value = item.dataset.id;
          const inputQuantity = document.createElement('input');
          inputQuantity.type = 'hidden';
          inputQuantity.name = `items[${index}][quantity]`;
          const quantity = parseInt(item.dataset.quantity, 10) || 1;
          inputQuantity.value = Math.max(1, quantity);
          this.form.querySelector('.pack-builder-summary--form--inputs').appendChild(inputId);
          this.form.querySelector('.pack-builder-summary--form--inputs').appendChild(inputQuantity);
        });
      }

      resetMainFormInputs() {
        this.form.querySelectorAll('input').forEach((input) => input.remove());
      }

      getDiscountCode(tresholdIndex) {
        if (tresholdIndex !== null) {
          this.discountCode = this.steps[tresholdIndex].dataset.discountCode;
        }
      }
    }
  );
}

if (!customElements.get('pack-builder-toggle-cross-sell')) {
  customElements.define(
    'pack-builder-toggle-cross-sell',

    class PackBuilderToggleCrossSell extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Attacher l'événement pour chaque produit cross-sell
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          product.querySelector('.deployer-switch--label').addEventListener('click', (event) => {
            if (event.target.tagName !== 'INPUT') {
              this.onToggleProduct.call(this, event, product);
            }
          });

          if (product.querySelector('.deployer-select') != null) {
            product
              .querySelector('.deployer-select')
              .addEventListener('change', (event) => this.variantChanged.call(this, event, product));
          }
        });
      }

      disconnectedCallback() {
        // Détacher les événements pour chaque produit cross-sell
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          product.querySelector('.deployer-switch--label').removeEventListener('click', (event) => {
            if (event.target.tagName !== 'INPUT') {
              this.onToggleProduct.call(this, event, product);
            }
          });

          if (product.querySelector('.deployer-select') != null) {
            product
              .querySelector('.deployer-select')
              .removeEventListener('change', (event) => this.variantChanged.call(this, event, product));
          }
        });
      }

      async onToggleProduct(event, productElement) {
        event.preventDefault();
        const checkbox = productElement.querySelector('input[type="checkbox"]');

        if (checkbox) {
          const isChecked = checkbox.checked;

          if (!isChecked) {
            checkbox.checked = true;
            productElement.classList.add('toggle-cross-sell__product--active');

            const variantData = await this.closest('.section')
              .querySelector('deployer-pack-builder')
              .getVariantData(checkbox.dataset.productHandle, checkbox.dataset.variantId);
            this.closest('.section')
              .querySelector('pack-builder-summary')
              .createVariantItem(variantData, productElement);
            this.closest('.section').querySelector('pack-builder-summary').increaseProductCount();
          } else {
            checkbox.checked = false;
            productElement.classList.remove('toggle-cross-sell__product--active');
            this.closest('.section').querySelector('pack-builder-summary').removeItem(checkbox.dataset.variantId);
          }
        }
      }

      variantChanged(event, product) {
        const select = product.querySelector('.deployer-select');
        const optionSelected = select.options[select.selectedIndex];
        this.updateProductPrice(product, optionSelected);
        this.updateProductImage(product, optionSelected);
        this.updateVariantId(product, optionSelected, event);
      }

      updateProductPrice(product, optionSelected) {
        const variantPrice = optionSelected.dataset.price;
        product.querySelector('.toggle-cross-sell__product-price').innerHTML = variantPrice;

        if (optionSelected.dataset.compareAtPrice != null) {
          if (product.querySelector('.toggle-cross-sell__product-compare-at-price')) {
            product.querySelector('.toggle-cross-sell__product-compare-at-price').innerHTML =
              optionSelected.dataset.compareAtPrice;
          }
          product.querySelector('.toggle-cross-sell__product-badge-discount').innerHTML =
            optionSelected.dataset.discountPercentage;
          if (product.querySelector('.toggle-cross-sell__product-compare-at-price')) {
            product.querySelector('.toggle-cross-sell__product-compare-at-price').style.display = 'block';
          }
          if (product.querySelector('.toggle-cross-sell__product-badge-discount')) {
            product.querySelector('.toggle-cross-sell__product-badge-discount').style.display = 'flex';
          }
        } else {
          if (product.querySelector('.toggle-cross-sell__product-compare-at-price')) {
            product.querySelector('.toggle-cross-sell__product-compare-at-price').style.display = 'none';
          }
          if (product.querySelector('.toggle-cross-sell__product-badge-discount')) {
            product.querySelector('.toggle-cross-sell__product-badge-discount').style.display = 'none';
          }
        }
      }

      updateProductImage(product, optionSelected) {
        if (
          optionSelected.dataset.variantImage != null &&
          product.querySelector('.toggle-cross-sell__product-image') != null
        ) {
          const variantImage = optionSelected.dataset.variantImage;
          product.querySelector('.toggle-cross-sell__product-image img').src = variantImage;
        }
      }

      updateVariantId(product, optionSelected, event) {
        const variantId = optionSelected.value;
        product.querySelector('.deployer-switch input').dataset.variantId = variantId;
        if (!product.querySelector('.deployer-switch input').checked) {
          this.onToggleProduct(event, product);
        }
      }
    }
  );
}